import { Injectable } from '@angular/core';
import { AsmEnablerService } from '@spartacus/asm/root';
import { FeatureModulesService, WindowRef } from '@spartacus/core';
import { LaunchDialogService } from '@spartacus/storefront';
import { Location } from '@angular/common';
@Injectable({
  providedIn: 'root',
})
export class KbAsmEnablerService extends AsmEnablerService {
  constructor(
    location: Location,
    winRef: WindowRef,
    launchDialogService: LaunchDialogService,
    featureModules: FeatureModulesService
  ) {
    super(location, winRef, launchDialogService, featureModules);
  }

  /**
   * Indicates whether ASM is launched through the URL,
   * using the asm flag in the URL.
   */
  override isLaunched(): boolean {
    const params = this.location.path().split('?')[1];
    return !!params && (params.split('&').includes('asm=true') || this.containsString(params.split('&'), 'uid='));
  }

  protected containsString(params: string[], findString: string) {
    return params.some((res) => {
      return res.indexOf(findString) > -1;
    });
  }
}
